import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tiktok = defineConnector({
  identifier: "tiktok",
  name: "TikTok",
  tagLine: "Short-form video platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://open\\.tiktokapis\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Set up TikTok API access",
      items: [
        {
          kind: "markdown",
          content:
            "Create an app at the [TikTok for Developers portal](https://developers.tiktok.com/) and complete the OAuth flow to obtain an access token.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://open.tiktokapis.com/v2/user/info/",
  },
});
